import { createSelector, createSlice, PayloadAction } from 'redux-starter-kit';
import { Resources, BroadcastMessagePriority } from '@erecruit/types';

import { selectAppState } from '../../../App/state/selectors';
import { ReadableBroadcastMessage, ResolveColorsType } from './types';

export interface BroadcastMessagesState {
  error?: string;
  messages: ReadableBroadcastMessage[];
}

const initialState: BroadcastMessagesState = {
  messages: [],
};

const resolveColors: ResolveColorsType = priority => {
  // eslint-disable-next-line default-case
  switch (priority) {
    case BroadcastMessagePriority.Info:
      return { alertColor: 'standard', fontColor: 'headerTertiary' };
    case BroadcastMessagePriority.Warning:
      return { alertColor: 'disabled', fontColor: 'linkSecondary' };
    case BroadcastMessagePriority.Important:
      return { alertColor: 'critical', fontColor: 'headerTertiary' };
  }
};

const BroadcastMessagesSlice = createSlice({
  slice: 'broadcastMessages',
  initialState: initialState,
  reducers: {
    fetchMessages() {},
    fetchMessagesSuccess(
      state,
      { payload }: PayloadAction<Resources.BroadcastMessage[]>,
    ) {
      const mappedMessages: ReadableBroadcastMessage[] = payload.map(x => ({
        ...x,
        colors: resolveColors(x.priority),
      }));

      state.messages = mappedMessages;
    },
    fetchMessagesFail(state, { payload: error }: PayloadAction<string>) {
      state.error = error;
    },
    markAsRead(state, { payload }: PayloadAction<ReadableBroadcastMessage[]>) {
      state.messages = payload;
    },
  },
});

const {
  actions,
  reducer,
  selectors: { getBroadcastMessages },
} = BroadcastMessagesSlice;

export const selectors = {
  selectBroadcastMessages: createSelector(
    [selectAppState],
    getBroadcastMessages,
  ),
};

export const {
  fetchMessages,
  fetchMessagesSuccess,
  fetchMessagesFail,
  markAsRead,
} = actions;

export default reducer;
